import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "contract-detail-monitor"
};
const _hoisted_2 = {
  key: 1,
  class: "contract-detail-monitor"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1,
  class: "result-nopick"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  key: 0,
  class: "result-nopick"
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  key: 0,
  class: "result-nopick"
};
const _hoisted_10 = {
  key: 1
};
const _hoisted_11 = {
  key: 0,
  class: "result-nopick"
};
const _hoisted_12 = {
  key: 1
};
const _hoisted_13 = {
  class: "contract-list-btn"
};
import { computed, onMounted, reactive, ref, toRefs, watch } from "vue";
import apis from "@/api";
import { ElLoading, ElMessage, ElMessageBox } from "element-plus";
import download from "@/utils/download";
import ImageViewer from '../components/ImageViewer';
import ImageHisViewer from '../components/ImageHisViewer';
import ReportDetailEdit from '../components/ReportDetailEdit';
export default {
  __name: 'AdvertLaunchResultDetail',
  props: {
    roleId: {
      type: String,
      default: ''
    },
    roleFlag: {
      type: String,
      default: ''
    },
    advertLaunch: {
      type: Object
    },
    currentAction: {
      type: String
    }
  },
  emits: ['submit'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const detailLoading = ref(false);
    const downLoading = ref(false);
    const taskEndDisabled = ref(false);
    const taskReportPreviewDisabled = ref(false);
    const viewerVisible = ref(false);
    const viewerHisVisible = ref(false);
    const reportEditVisible = ref(false);
    const actionButtonShow = ref(true);
    const {
      downMonitorResultPdf
    } = download();
    const headerStyle = ref({
      background: '#FAFAFA',
      textAlign: 'center'
    });
    const props = __props;
    const data = reactive({
      tableData: [],
      pagination: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      },
      detailReport: {},
      oldDetailReport: {},
      reportFile: {},
      queryParam: {
        hasHis: null,
        monitorPublicFit: null,
        timeFit: null,
        locationFit: null
      }
    });
    const handleSizeChange = val => {
      data.pagination.pageSize = val;
      loadData();
    };
    const handleCurrentChange = val => {
      data.pagination.pageNo = val;
      loadData();
    };

    //预览对比图
    const handleComparePreview = row => {
      data.leftFiles = [];
      data.rightFiles = [];
      const publicImg = {
        imgId: row.publicImgId,
        imgName: row.publicImgName,
        imgUrl: row.publicImgUrl
      };
      data.leftFiles.push(publicImg);
      const monitorImg = {
        imgId: row.imgId,
        imgName: row.imgName,
        imgUrl: row.imgUrl
      };
      data.rightFiles.push(monitorImg);
      viewerVisible.value = true;
    };

    //预览历史图
    const handleHisPreview = row => {
      data.hisFiles = [];
      let simInfo = row.simInfo;
      const simArray = JSON.parse(simInfo);
      if (simArray) {
        simArray.forEach(sima => {
          const hisImg = {
            imgId: sima.id,
            imgName: sima.fileName,
            imgUrl: sima.innerUrl
          };
          data.hisFiles.push(hisImg);
        });
      }
      viewerHisVisible.value = true;
    };

    //复核
    const handleInspect = row => {
      reportEditVisible.value = true;
      data.detailReport = row;
      data.detailReport.action = "check";
      data.detailReport.roleFlag = props.roleFlag;
      data.oldDetailReport = row;
    };
    //复核记录
    const handleInspectRecord = row => {
      reportEditVisible.value = true;
      data.detailReport = row.checkRecord;
      data.detailReport.action = "record";
      data.detailReport.roleFlag = props.roleFlag;
      data.oldDetailReport = row;
    };
    const loadData = () => {
      const params = {
        advertLaunchId: props.advertLaunch.id,
        ...data.pagination,
        ...data.queryParam
      };
      detailLoading.value = true;
      apis.getAdvertLaunchMonitorReportPage(params).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          data.tableData = records;
          data.pagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        detailLoading.value = false;
      });
    };
    const loadReportFile = () => {
      const params = {
        advertLaunchId: props.advertLaunch.id
      };
      apis.loadReportFile(params).then(res => {
        if (res.success) {
          data.reportFile = res.data;
          if (data.reportFile) {
            taskReportPreviewDisabled.value = true;
          }
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {});
    };
    //预览比对报告
    const previewResultView = () => {
      if (data.reportFile) {
        window.open(data.reportFile.fileUrl);
        return;
      }
    };
    /*//生成结果报告 并上传至文件服务
    const downResultView = () => {
    
      downLoading.value = true
      const name =  props.advertLaunch.taskName + '.pdf'
      downMonitorResultPdf(props.advertLaunch.id, name).then((res) => {
    
        const formData = new FormData()
        const fileOfBlob = new File([res], name)
        formData.append('fileList', fileOfBlob)
        apis.upload(formData).then((res) => {
    
          if (res && res.success) {
            const reportFile = {
              advertLaunchId:props.advertLaunch.id,
              fileId: res.data[0].id,
              fileName:res.data[0].fileName,
              fileUrl:res.data[0].innerUrl,
              fileType:res.data[0].fileType,
              uploadTime:res.data[0].uploadTime,
              uploadUser:res.data[0].operator
            }
            apis.saveLaunchReportFileInfo(reportFile).then(res => {
              if (res.success) {
                data.reportFile = reportFile
                console.log("report save successful",data.reportFile)
              }else{
                console.log(res.msg)
              }
            }).catch(err => {}).finally(() => {})
          }
    
        }).catch((err) => {
          console.log("err", err)
        })
        downLoading.value = false
      }).finally(() => {
        downLoading.value = false
      })
    }*/

    //任务结束
    const handleTaskEnd = () => {
      taskEndDisabled.value = true;
      const loadingInstance = ElLoading.service({
        lock: true,
        text: 'Loading 生成比对报告及结束任务 进行中',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      if (props.advertLaunch.monitorState != 0 && props.advertLaunch.monitorState != 12) {
        ElMessage.error("监测状态有误!");
        loadingInstance.close();
        return;
      }
      const param = {
        advertLaunchId: props.advertLaunch.id
      };
      const name = props.advertLaunch.taskName + '.pdf';
      apis.handleLauchTaskEnd(param).then(res => {
        if (res.success) {
          ElMessage.success('任务结束成功!');
          // 任务结束后关闭dialog
          emits('submit');
        } else {
          ElMessage.error(res.msg);
          taskEndDisabled.value = false;
        }
      }).catch(err => {
        ElMessage.error(err);
        taskEndDisabled.value = false;
      }).finally(() => {
        loadingInstance.close();
      });
      downMonitorResultPdf(props.advertLaunch.id, name).then(res => {
        const formData = new FormData();
        const fileOfBlob = new File([res], name);
        formData.append('fileList', fileOfBlob);
        formData.append('bucketName', 'outer-for-inner');
        apis.upload(formData).then(res => {
          if (res && res.success) {
            const reportFile = {
              advertLaunchId: props.advertLaunch.id,
              fileId: res.data[0].id,
              fileName: res.data[0].fileName,
              fileUrl: res.data[0].relativeUrl,
              fileType: res.data[0].fileType,
              uploadTime: res.data[0].uploadTime,
              uploadUser: res.data[0].operator
            };
            apis.saveLaunchReportFileInfo(reportFile).then(res => {
              if (res.success) {
                data.reportFile = reportFile;
                if (data.reportFile) {
                  taskReportPreviewDisabled.value = true;
                }
                console.log("report file info save successful", data.reportFile);
              }
            }).catch(err => {
              console.error("report file info save error", err);
            });
          } else {
            console.error("report upload error", res.msg);
          }
        }).catch(err => {
          console.error("report upload error", err);
        });
      }).catch(err => {
        console.error("make report pdf error", err);
      });
    };
    const handleFilterChange = filters => {
      console.log("filters", filters);
      if (filters.hasHis) {
        data.queryParam.hasHis = filters.hasHis[0];
      }
      if (filters.monitorPublicFit) {
        data.queryParam.monitorPublicFit = filters.monitorPublicFit[0];
      }
      if (filters.timeFit) {
        data.queryParam.timeFit = filters.timeFit[0];
      }
      if (filters.locationFit) {
        data.queryParam.locationFit = filters.locationFit[0];
      }
      if (filters.checkRecordFlag) {
        data.queryParam.checkRecordFlag = filters.checkRecordFlag[0];
      }
      loadData();
    };

    //提交复核
    const handleSubmitCheckRecord = () => {
      const param = {
        advertLaunchId: props.advertLaunch.id
      };
      apis.handleSubmitCheckRecord(param).then(res => {
        if (res.success) {
          ElMessage.success('提交复核成功!');
          emits('submit');
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {});
    };

    //复核审核结果提交
    const handleAuditSubmitCheckRecord = () => {
      const param = {
        advertLaunchId: props.advertLaunch.id
      };
      apis.handleAuditSubmitCheckRecord(param).then(res => {
        if (res.success) {
          ElMessage.success('复核审核结果提交成功!');
          emits('submit');
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {});
    };
    watch(() => props.advertLaunch.monitorState, (newvalue, oldvalue) => {
      if (newvalue == 9) {
        //监测状态为9已结束
        taskEndDisabled.value = true;
      }
      if (newvalue == 6 || newvalue == 13) {
        //6为比对中，已从首页限制进入到此页面还是加一下限制
        taskEndDisabled.value = true;
      }
      if (newvalue == 10 || newvalue == 11) {
        actionButtonShow.value = false;
        taskEndDisabled.value = true;
      }
    }, {
      deep: false,
      immediate: true
    });
    onMounted(() => {
      loadData();
      loadReportFile();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [actionButtonShow.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [__props.roleFlag == '2' ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        style: {
          "margin-left": "10px"
        },
        type: "primary",
        onClick: handleTaskEnd,
        disabled: taskEndDisabled.value
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("任务结束", -1)]))]),
        _: 1
      }, 8, ["disabled"])) : _createCommentVNode("", true), __props.roleFlag == '2' && __props.advertLaunch.monitorState != 9 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        style: {
          "margin-left": "10px"
        },
        type: "primary",
        onClick: handleSubmitCheckRecord,
        disabled: taskEndDisabled.value
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("提交复核", -1)]))]),
        _: 1
      }, 8, ["disabled"])) : _createCommentVNode("", true), taskReportPreviewDisabled.value ? (_openBlock(), _createBlock(_component_el_button, {
        key: 2,
        type: "primary",
        onClick: previewResultView
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("预览比对报告", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), !actionButtonShow.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [__props.roleFlag == '1' ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        style: {
          "margin-left": "10px"
        },
        type: "primary",
        onClick: handleAuditSubmitCheckRecord
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("复核审核结果提交", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", null, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        border: "",
        data: data.tableData,
        style: {
          "width": "100%"
        },
        "header-cell-style": headerStyle.value,
        "cell-style": {
          'text-align': 'center'
        },
        onFilterChange: handleFilterChange
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "publicImgUrl",
          label: "投放内容及画面"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", null, [_createVNode(_component_el_image, {
            src: scope.row.publicImgUrl,
            "preview-src-list": [scope.row.publicImgUrl],
            "preview-teleported": ""
          }, null, 8, ["src", "preview-src-list"])])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "imgUrl",
          label: "监测图片"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", null, [_createVNode(_component_el_image, {
            src: scope.row.imgUrl,
            "preview-src-list": [scope.row.imgUrl],
            "preview-teleported": ""
          }, null, 8, ["src", "preview-src-list"])])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "hasHis",
          label: "历史图片",
          "column-key": "hasHis",
          filters: [{
            text: '无相似',
            value: 0
          }, {
            text: '有相似',
            value: 1
          }],
          "filter-multiple": false
        }, {
          default: _withCtx(scope => [scope.row.hasHis === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_3, "无相似")) : _createCommentVNode("", true), scope.row.hasHis === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_4, "有相似")) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "hisCount",
          label: "历史图片数量"
        }, {
          default: _withCtx(scope => [scope.row.simInfo ? (_openBlock(), _createElementBlock("span", _hoisted_5, [_createVNode(_component_el_link, {
            type: "danger",
            onClick: _withModifiers($event => handleHisPreview(scope.row), ["stop"])
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.hisCount), 1)]),
            _: 2
          }, 1032, ["onClick"])])) : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(scope.row.hisCount), 1))]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "monitorPublicFit",
          label: "监测图片与投放图片一致性",
          "column-key": "monitorPublicFit",
          filters: [{
            text: '不一致',
            value: 0
          }, {
            text: '一致',
            value: 1
          }],
          "filter-multiple": false
        }, {
          default: _withCtx(scope => [scope.row.monitorPublicFit === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_7, "不一致")) : _createCommentVNode("", true), scope.row.monitorPublicFit === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_8, "一致")) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "timeFit",
          label: "时间比对",
          "column-key": "timeFit",
          filters: [{
            text: '不符合',
            value: 0
          }, {
            text: '符合',
            value: 1
          }],
          "filter-multiple": false
        }, {
          default: _withCtx(scope => [scope.row.timeFit === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_9, "不符合")) : _createCommentVNode("", true), scope.row.timeFit === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_10, "符合")) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "locationFit",
          label: "位置比对",
          "column-key": "locationFit",
          filters: [{
            text: '不符合',
            value: 0
          }, {
            text: '符合',
            value: 1
          }],
          "filter-multiple": false
        }, {
          default: _withCtx(scope => [scope.row.locationFit === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_11, "不符合")) : _createCommentVNode("", true), scope.row.locationFit === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_12, "符合")) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "人工复核",
          width: "150",
          prop: "checkRecordFlag",
          "column-key": "checkRecordFlag",
          filters: [{
            text: '无复核数据',
            value: 0
          }, {
            text: '有复核数据',
            value: 1
          }],
          "filter-multiple": false
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_button, {
            link: "",
            size: "small",
            type: "primary",
            onClick: $event => handleComparePreview(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("预览对比图", -1)]))]),
            _: 1
          }, 8, ["onClick"]), __props.roleFlag == '2' && __props.advertLaunch.monitorState != 9 && !scope.row.checkRecord && !taskEndDisabled.value ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            size: "small",
            type: "primary",
            onClick: $event => handleInspect(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("复核", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true), (__props.advertLaunch.monitorState == 0 || __props.advertLaunch.monitorState == 9 || __props.advertLaunch.monitorState == 10 || __props.advertLaunch.monitorState == 11 || __props.advertLaunch.monitorState == 12) && (__props.roleFlag == '0' || __props.roleFlag == '1' || __props.roleFlag == '2' || __props.roleFlag == '3') && scope.row.checkRecord ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            link: "",
            size: "small",
            style: _normalizeStyle([{
              "color": "red"
            }, {
              'color': scope.row.checkRecord.auditState == null ? 'red' : ''
            }]),
            onClick: $event => handleInspectRecord(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("复核数据", -1)]))]),
            _: 1
          }, 8, ["style", "onClick"])) : _createCommentVNode("", true)])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "header-cell-style"])), [[_directive_loading, detailLoading.value]])]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        "page-sizes": [10, 20, 50, 100, 200],
        "page-size": data.pagination.pageSize,
        total: data.pagination.totalSize,
        currentPage: data.pagination.pageNo,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => data.pagination.pageNo = $event),
        layout: "total, prev, pager, next, sizes, jumper"
      }, null, 8, ["page-size", "total", "currentPage"])]), _createVNode(_unref(ImageViewer), {
        visible: viewerVisible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = $event => viewerVisible.value = $event),
        "left-files": data.leftFiles,
        "right-file": data.rightFiles
      }, null, 8, ["visible", "left-files", "right-file"]), _createVNode(_unref(ReportDetailEdit), {
        visible: reportEditVisible.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = $event => reportEditVisible.value = $event),
        onSuccess: loadData,
        detailReport: data.detailReport,
        oldDetailReport: data.oldDetailReport
      }, null, 8, ["visible", "detailReport", "oldDetailReport"]), _createVNode(_unref(ImageHisViewer), {
        visible: viewerHisVisible.value,
        "onUpdate:visible": _cache[3] || (_cache[3] = $event => viewerHisVisible.value = $event),
        "left-files": data.hisFiles
      }, null, 8, ["visible", "left-files"])], 64);
    };
  }
};